import { ArrowBack } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/system/Unstable_Grid";
import { map } from "lodash";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FormatImage } from "../../../components/FormatImage";
import { STATIC_FORMATS } from "../../../utils/constants";

type SelectedFormatProps = {
  onChange: (format: any) => void;
};

export function SelectedFormat({ onChange }: SelectedFormatProps) {
  const navigate = useNavigate();
  const handleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const handleClick = useCallback(
    (format: any) => {
      onChange(format);
    },
    [onChange]
  );

  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction="row">
        <Button
          onClick={handleGoBack}
          size="small"
          color="primary"
          startIcon={<ArrowBack />}
        >
          Voltar
        </Button>
        <Typography variant="h6">
          Qual formato de imagem você deseja criar ?
        </Typography>
      </Stack>
      <Grid container spacing={2}>
        {map(STATIC_FORMATS, (format, index) => (
          <Grid xs={2} key={index}>
            <FormatImage
              onClick={() => handleClick(format)}
              image={format.image}
              title={format.title}
              subtitle={format.subtitle}
              isVideo={format.isVideo}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
